/**
 * <h4>Product view send Error</h4>
 *
 * An error can be thrown from {@link sendProductView} invocation
 */
export class ProductViewError extends Error {
    constructor(message: string) {
        super(message)
        Object.setPrototypeOf(this, ProductViewError.prototype)
    }
}